module.exports = __webpack_public_path__ + "img/ko_ko.332005f5.png";